import { render, staticRenderFns } from "./ExternalVenues.vue?vue&type=template&id=1255428b&scoped=true&"
import script from "./ExternalVenues.vue?vue&type=script&lang=ts&"
export * from "./ExternalVenues.vue?vue&type=script&lang=ts&"
import style0 from "./ExternalVenues.vue?vue&type=style&index=0&id=1255428b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1255428b",
  null
  
)

export default component.exports